import { useRef } from "react";
import { useLocation } from "react-router-dom";
import AboutMe from "./AboutMe";
import HeaderPart from "./Header";
import HomePage from "./HomePage";
import ContactPart from "./ContactPart";
import MyProjects from "./MyProjects";
import EducationPart from "./EducationPart";
import { useEffect } from "react";
import GoodBye from "./GoodBye";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import "./styles/MainRouter.css";
import Header from "./Header";

const MainRouter = () => {
  const [isOpen, setIsOpen] = useState(true);
  const aboutMeRef = useRef(null);
  const contactRef = useRef(null);
  const myProjectsRef = useRef(null);
  const HomePageRef = useRef(null);
  const GalleryRef = useRef(null);
  const EducationRef = useRef(null);
  const GoodByeRef = useRef(null);
  const location = useLocation();
  const Navigate = useNavigate();

  const scrollToRef = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (location.pathname === "/") {
      scrollToRef(HomePageRef);
    } else if (location.pathname === "/About-me") {
      scrollToRef(aboutMeRef);
    } else if (location.pathname === "/Education") {
      scrollToRef(EducationRef);
    } else if (location.pathname === "/MyProjects") {
      scrollToRef(myProjectsRef);
    } else if (location.pathname === "/contact") {
      scrollToRef(contactRef);
    } else if (location.pathname === "/GoodBye") {
      scrollToRef(GoodByeRef);
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.keyCode === 40) {
        event.preventDefault();
        if (location.pathname === "/") {
          scrollToRef(aboutMeRef);
          Navigate("/About-me");
        } else if (location.pathname === "/About-me") {
          Navigate("/Education");
          scrollToRef(EducationRef);
        } else if (location.pathname === "/Education") {
          scrollToRef(myProjectsRef);
          Navigate("/MyProjects");
        } else if (location.pathname === "/MyProjects") {
          scrollToRef(GalleryRef);
          Navigate("/contact");
        } else if (location.pathname === "/contact") {
          scrollToRef(GoodByeRef);
          Navigate("/GoodBye");
        } else if (location.pathname === "/GoodBye") {
          scrollToRef(HomePageRef);
          Navigate("/");
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [
    aboutMeRef,
    EducationRef,
    myProjectsRef,
    GalleryRef,
    contactRef,
    GoodByeRef,
    location.pathname,
  ]);
  const refs = [
    HomePageRef,
    aboutMeRef,
    EducationRef,
    myProjectsRef,
    GalleryRef,
    contactRef,
    GoodByeRef,
  ];

  const getNextRef = (currentRef) => {
    const index = refs.indexOf(currentRef);
    if (index === refs.length - 1) {
      return contactRef;
    } else {
      return refs[index + 1];
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.keyCode === 40) {
        event.preventDefault();
        const currentRef = refs.find(
          (ref) => ref.current.getBoundingClientRect().top >= 0
        );
        const nextRef = getNextRef(currentRef);
        scrollToRef(nextRef);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [refs]);

  return (
    <>
      <Header />
      {/* <HeaderPart isOpen={isOpen} setIsOpen={setIsOpen} /> */}
      <div ref={HomePageRef} className="sectionMain" >
        <HomePage isOpen={isOpen} setIsOpen={setIsOpen} />
      </div>
      <div ref={aboutMeRef} className="section" id="sectionAboutMe">
        <AboutMe setIsOpen={setIsOpen} />
      </div>
      <div ref={EducationRef} className="section" id="sectionEdu">
        <EducationPart setIsOpen={setIsOpen} />
      </div>
      <div ref={myProjectsRef} id="sectionProject" className="section">
        <MyProjects setIsOpen={setIsOpen} />
      </div>
      <div ref={contactRef} className="section" id="sectionContact">
        <ContactPart setIsOpen={setIsOpen} />
      </div>
      <div ref={GoodByeRef} className="section" id="GoodbyeSection">
        <GoodBye />
      </div>
    </>
  );
};

export default MainRouter;
